import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import * as SharedActions from 'redux/modules/shared';
import * as UserActions from 'redux/modules/users';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Button, Select} from 'ui-library';
import i18n from 'i18n';
import {get} from 'lodash';

import DebounceInput from 'apps/shared/components/DebounceInput';
import WizardItem from './wizard-item';
import Dialog from './dialog';
import SettingsSocialConnectAccount from './settings-social-connect-account';
import tracking from '../lib/tracking/user';
import AccountDataForm from 'apps/shared/controllers/AccountDataForm/AccountDataForm';
import { getDefaultTitle } from 'config/app';

const Wizard = createClass({
  propTypes: {
    onClose: PropTypes.func,
    account: PropTypes.object,
    user: PropTypes.object,
    logout: PropTypes.func.isRequired,
    onLogout: PropTypes.func
  },

  getInitialState() {
    const currentDialogStep = 1;
    const {email, verifiedEmails, hasCompletePersonalInfo} = this.props.user;
    const verifiedEmail = (verifiedEmails.length > 0) && (verifiedEmails.indexOf(email.toLowerCase()) !== -1);

    if (verifiedEmail && hasCompletePersonalInfo) this.onDialogDone();

    return {
      currentDialogStep,
      email,
      editEmail: false,
      advSavedProfile: false,
      advSavedLocation: false,
      companyType: 'none',
      budget: 'none'
    };
  },

  onDialogDone() {
    this.props.onClose();
  },

  afterAccountDataSave() {
    tracking.track('ANY - Completed Basic Data');
    tracking.track('ANY - Completed Location Data');
    this.onNextClick();
  },

  onNextClick() {
    this.setState({
      currentDialogStep: this.state.currentDialogStep + 1
    });
  },

  onPreviousClick() {
    this.setState({
      currentDialogStep: this.state.currentDialogStep - 1
    });
  },

  logoutHandler() {
    const {logout, onLogout} = this.props;

    onLogout();
    logout();
  },

  onSocialNetworkRedirect(params) {
    const SOCIAL_NETWORKS = ['facebook', 'instagram'];
    if (SOCIAL_NETWORKS.indexOf(params.socialNetwork) > -1) return this.onDialogDone();
  },

  getDialogHeader(role) {
    if (role === 'influencer') {
      return (
        <div className='flex center-xs width100'>
          <WizardItem
            number={1}
            title={i18n.get('REGISTER_PERSONAL_INFO_STEP_TITLE')}
            text={i18n.get('REGISTER_PERSONAL_INFO_STEP_SUBTITLE')}
            step={1}
            currentStep={this.state.currentDialogStep}
          />
          <WizardItem
            number={2}
            title={i18n.get('REGISTER_SOCIAL_NETWORKS_STEP_TITLE')}
            text={i18n.get('REGISTER_SOCIAL_NETWORKS_STEP_SUBTITLE')}
            step={2}
            currentStep={this.state.currentDialogStep}
          />
        </div>
      );
    }
    if (role === 'advertiser') {
      return (
        <div className='flex center-xs width100'>
          <WizardItem
            number={1}
            title={i18n.get('REGISTER_ACCOUNT_STEP_TITLE')}
            text={i18n.get('REGISTER_PERSONAL_INFO_STEP_SUBTITLE')}
            step={1}
            currentStep={this.state.currentDialogStep}
          />
          <WizardItem
            number={2}
            title={i18n.get('REGISTER_INFO_STEP_TITLE')}
            text={i18n.get('REGISTER_INFO_STEP_SUBTITLE')}
            step={2}
            currentStep={this.state.currentDialogStep}
          />
        </div>
      );
    }
    return (
      <div className='flex center-xs width100'>
        <WizardItem
          number={1}
          title={i18n.get('REGISTER_ACCOUNT_STEP_TITLE')}
          text={i18n.get('REGISTER_PERSONAL_INFO_STEP_SUBTITLE')}
          step={1}
          currentStep={this.state.currentDialogStep}
        />
      </div>
    );
  },

  getAccountInfoView() {
    const {user} = this.props;

    const content = (
      <div className='vf-wrapper' id='user-info-view'>
        <AccountDataForm
          user={user}
          onAfterSave={user.role === 'admin' ? this.onDialogDone : this.afterAccountDataSave}
        />
      </div>
    );

    return {content};
  },

  getSocialNetworksView() {
    const content = (
      <React.Fragment>
        <SettingsSocialConnectAccount onRedirect={this.onSocialNetworkRedirect} />

        <div className='margin-top-3x width100 flex between-xs padding-2x'>
          <Button
            className='vf-text-primary vf-font-bold'
            color='flat'
            onClick={this.logoutHandler}
          >
            {i18n.get('LOGOUT')}
          </Button>

          <div className='flex'>
            <Button
              className='margin-right-1x'
              onClick={this.onPreviousClick}
              size='sm'
              style={{padding: '1rem 3rem', borderRadius: '2px'}}
            >
              {i18n.get('BACK')}
            </Button>

            <Button
              color='primary'
              onClick={this.onDialogDone}
              size='sm'
              style={{padding: '1rem 3rem', borderRadius: '2px'}}
            >
              {i18n.get('FINISH')}
            </Button>
          </div>
        </div>
      </React.Fragment>
    );

    return {content};
  },

  saveSurveyData() {
    const {user, survey} = this.props;
    const parseValue = (val) => {
      return val && val !== 'none' ? val : null;
    };

    const companyWebsite = parseValue(document.getElementById('companyWebsite').value);
    const companyType = parseValue(this.state.companyType);
    const budget = parseValue(this.state.budget);

    const params = {
      id: user.id,
      companyWebsite,
      companyType,
      budget
    };

    survey(params);
    this.onDialogDone();
  },

  getCompanySurveryView() {
    const {user,currency} = this.props;
    const domain = user.email.replace(/.*@/, '');
    const common = ['gmail', 'hotmail', 'outlook', 'yahoo'];

    const symbol = get(currency,'symbol','');
    const suffix = get(currency,'suffix','');

    const content = (
      <React.Fragment>
        <div className='vf-wrapper' style={{margin: '0 auto'}}>
          <div className='vf-simple-form-label'>
            {i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_COMPANY_NAME')}
          </div>
          <DebounceInput
            defaultValue={common.includes(domain.split('.')[0]) ? '' : `http://${domain}`}
            id='companyWebsite'
          />

          <div className='vf-simple-form-label'>
            {i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_WHY_VOXFEED',{companyName:getDefaultTitle()})}
          </div>
          <Select
            value={this.state.companyType}
            selectClassname='width100'
            buttonClassname='width100 vf-bg-white-light-color vf-border-gray-color flex between-xs'
            className='width100'
            onChange={(e, companyType) => this.setState({companyType})}
            options={{
              none: '',
              BRAND: i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_OPTION_BRAND'),
              AGENCY: i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_OPTION_AGENCY')
            }}
          />

          <div className='vf-simple-form-label'>
            {i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_HOW_MUCH')}
          </div>
          <Select
            value={this.state.budget}
            selectClassname='width100'
            buttonClassname='width100 vf-bg-white-light-color vf-border-gray-color flex between-xs'
            className='width100'
            onChange={(e, budget) => this.setState({budget})}
            options={{
              'none': '',
              '1_1K_PER_MONTH': i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_OPTION_1',{symbol,suffix}),
              '1K_10K_PER_MONTH': i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_OPTION_1k',{symbol,suffix}),
              '10K_PLUS_PER_MONTH': i18n.get('ADV_SETTINGS_ACCOUNT_CONTENT_OPTION_10k',{symbol,suffix})
            }}
          />

        </div>

        <div className='margin-top-3x width100 flex between-xs padding-2x'>
          <Button
            className='vf-text-primary vf-font-bold'
            color='flat'
            onClick={this.onDialogDone}
          >
            {i18n.get('SKIP')}
          </Button>

          <div className='flex'>
            <Button
              className='margin-right-1x'
              onClick={this.onPreviousClick}
              size='sm'
              style={{padding: '1rem 3rem', borderRadius: '2px'}}
            >
              {i18n.get('BACK')}
            </Button>

            <Button
              color='primary'
              onClick={this.saveSurveyData}
              size='sm'
              style={{padding: '1rem 3rem', borderRadius: '2px'}}
            >
              {i18n.get('FINISH')}
            </Button>
          </div>
        </div>
      </React.Fragment>
    );

    return {content};
  },

  getInfluencerDialogViews() {
    return [
      this.getAccountInfoView(),
      this.getSocialNetworksView()
    ];
  },

  getAdvertiserDialogViews() {
    return [
      this.getAccountInfoView(),
      this.getCompanySurveryView()
    ];
  },

  getDialogViews(role) {
    if (role === 'influencer') return this.getInfluencerDialogViews();
    if (role === 'advertiser') return this.getAdvertiserDialogViews();

    return [
      this.getAccountInfoView()
    ];
  },

  render() {
    const {currentDialogStep} = this.state;
    const {user} = this.props;
    const dialogHeader = this.getDialogHeader(user.role);
    const dialogViews = this.getDialogViews(user.role);
    const dialogView = dialogViews[currentDialogStep - 1];

    return (
      <Dialog
        header={dialogHeader}
        content={dialogView.content}
        footer={dialogView.footer}
        key='home-dialog'
        onClose={null}
        dismissable={false}
      />
    );
  }
});

const mapDispatchToProps = dispatch => bindActionCreators({
  logout: SharedActions.logout,
  survey: UserActions.survey
}, dispatch);

function mapStateToProps({app}) {
  const {systemSettings} = app;
  const {currency} = systemSettings
  return {
    currency
  };
}

module.exports = connect(mapStateToProps, mapDispatchToProps)(Wizard);
